import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { getCurrencySymbol } from '@angular/common';
import { REPAIR_TYPE, StrategyFormBuildMode } from '../../strategy.enums';

@Component({
  selector: 'app-repair-condition',
  templateUrl: './repair-condition.component.html',
  styleUrls: ['./repair-condition.component.scss']
})
export class RepairConditionComponent implements OnInit {
  @Input() strategyMode$: BehaviorSubject<StrategyFormBuildMode>;
  useAdvanceExit = true;
  currencySymbol = getCurrencySymbol('INR', 'narrow');
  REPAIR_TYPE = REPAIR_TYPE;

  constructor() { }

  ngOnInit(): void {
  }

}
